module.exports = __webpack_public_path__ + "NPI2icon.png?fe977df07e6c688ff302d16b701142e4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbs/NPI2icon.png
// module id = 42
// module chunks = 0